import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWsLogo50 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 160 88"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <mask
      id="ws-logo-50_svg__a"
      width={90}
      height={88}
      x={70}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M114.856 88c24.417 0 44.211-19.693 44.211-43.986 0-24.295-19.794-43.988-44.211-43.988s-44.21 19.693-44.21 43.988C70.645 68.307 90.438 88 114.855 88"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#ws-logo-50_svg__a)">
      <mask
        id="ws-logo-50_svg__b"
        width={184}
        height={123}
        x={0}
        y={-33}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M0 89.126h184V-32.208H0z"
        />
      </mask>
      <g mask="url(#ws-logo-50_svg__b)">
        <path
          fill="#60D15D"
          d="M63.979 94.667h101.754V-6.641H63.979z"
        />
      </g>
    </g>
    <mask
      id="ws-logo-50_svg__c"
      width={132}
      height={36}
      x={0}
      y={34}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m84.041 35.596 4.954-1.216v3.704h4.119a10.66 10.66 0 0 0-2.323 3.89h-1.796v5.082q0 .865.76.865c.229 0 .576-.06.914-.16.35 1.226.934 2.374 1.706 3.4-1.046.594-2.546 1.003-3.925 1.003q-2.04 0-3.225-1.243-1.182-1.243-1.184-3.486v-5.46h-2.04v-3.89h2.04zm34.107-1.432h4.968v17.73h-4.695V50.36q-.464.97-1.556 1.388a6 6 0 0 1-2.156.417q-2.84 0-4.45-2.02t-1.611-5.121q0-3.1 1.666-5.133 1.663-2.035 4.558-2.034 2.156 0 3.276 1.428zm-3.821 12.893q.626.797 1.61.797.982 0 1.61-.797.629-.794.628-2.034.001-1.24-.628-2.048-.628-.809-1.61-.808-.984 0-1.61.808-.629.807-.629 2.048 0 1.24.629 2.034m-20.065-7.181q1.61-2.02 4.448-2.02 1.067 0 2.157.417 1.093.418 1.557 1.387v-1.536h4.695v13.77h-4.695V50.36q-.464.97-1.557 1.388a6 6 0 0 1-2.157.417q-2.837 0-4.448-2.02-1.613-2.021-1.612-5.121 0-3.126 1.611-5.147m4.067 7.181q.627.797 1.611.797.982 0 1.611-.797.627-.794.626-2.034 0-1.24-.626-2.048-.63-.809-1.61-.808-.985 0-1.612.808-.629.807-.629 2.048 0 1.24.63 2.034m-27.286-7.989q1.678-1.214 4.053-1.212 3.195-.001 5.65 1.294l-1.472 3.286q-2.103-.809-4.015-.809-.873 0-.874.433.001.323.71.564.711.243 1.721.514 1.01.27 2.034.686 1.023.419 1.734 1.347.709.93.71 2.25-.001 1.294-.656 2.278-.654.984-1.693 1.495a9.1 9.1 0 0 1-4.068.97q-3.876 0-5.786-1.644l1.584-3.448q.9.593 1.813.875.915.283 2.417.283.11 0 .381-.04a2.7 2.7 0 0 0 .63-.19c.236-.097.353-.23.353-.39a.29.29 0 0 0-.081-.215.9.9 0 0 0-.272-.163 4 4 0 0 0-.328-.12 7 7 0 0 0-.479-.11l-.477-.093q-2.513-.592-3.89-1.643-1.379-1.051-1.378-2.83 0-2.155 1.679-3.368m-12.567.567q1.556-1.78 4.204-1.779 1.283 0 2.224.417.941.418 1.448 1.011.504.592.79 1.508.289.916.354 1.672.07.755.07 1.75v7.68h-4.968v-7.06q0-2.398-1.557-2.398-1.065-.001-1.678.823-.615.822-.615 2.141v6.495H53.78V38.124h4.696zm-19.273.296q2.17-2.076 5.364-2.075 3.195-.001 5.365 2.075t2.17 5.092q0 2.992-2.17 5.067-2.17 2.073-5.365 2.074-3.193 0-5.364-2.074t-2.171-5.067q0-3.018 2.17-5.092m3.547 7.126q.698.797 1.817.797 1.12 0 1.816-.797.696-.794.696-2.034t-.71-2.048q-.71-.809-1.802-.808-1.09 0-1.802.808c-.472.538-.712 1.221-.712 2.048q.002 1.24.698 2.034m-19.947-7.126q2.167-2.076 5.364-2.075 3.192-.001 5.364 2.075 2.17 2.075 2.17 5.092 0 2.992-2.17 5.067-2.172 2.073-5.364 2.074-3.197 0-5.364-2.074-2.172-2.074-2.171-5.067 0-3.018 2.17-5.092m3.547 7.126q.696.797 1.817.797t1.814-.797q.696-.794.696-2.034t-.709-2.048q-.71-.809-1.801-.808-1.093 0-1.803.808-.71.807-.71 2.048 0 1.24.697 2.034m-10.926-8.933h4.832l-4.206 13.77h-4.53l-1.392-8.03-1.392 8.03H4.204L0 38.125h4.832l1.665 8.03 1.174-8.03h4.913l1.175 8.03zM125.371 49.26a2.98 2.98 0 0 1 2.988-2.971 2.98 2.98 0 0 1 2.988 2.971 2.98 2.98 0 0 1-2.988 2.972 2.98 2.98 0 0 1-2.988-2.971m-65.345 19.23.338-.215.47.848-.06.048c-.693.55-1.517.828-2.453.828-.835 0-1.535-.281-2.078-.834-.541-.554-.817-1.504-.817-2.824v-6.478h-6.071v6.478c0 1.794.605 2.667 1.853 2.667q.505 0 .997-.174c.327-.116.567-.232.707-.344l.339-.215.469.848-.06.048c-.692.55-1.517.828-2.452.828-.836 0-1.536-.281-2.079-.834-.543-.555-.815-1.504-.815-2.824v-6.478h-1.65v-.99h1.65v-2.67h1.04v2.67h6.072v-2.67h1.04v2.67h4.185v.99h-4.184v6.478c0 1.794.607 2.667 1.854 2.667.334 0 .67-.058.998-.174s.566-.232.706-.344m-30.949-7.447c.87-1.59 2.335-2.394 4.361-2.394h.091v1.147h-.09c-.516 0-1.02.078-1.499.23a4.8 4.8 0 0 0-1.396.739c-.446.331-.804.824-1.067 1.464-.265.642-.4 1.406-.4 2.273v5.272h-1.042V58.873h1.042zm14.258 6.59c.897-.911 1.351-2.026 1.351-3.31s-.454-2.398-1.351-3.31c-.897-.913-2-1.374-3.28-1.374s-2.383.462-3.28 1.374c-.896.911-1.352 2.026-1.352 3.31s.456 2.399 1.352 3.31c.897.913 2.001 1.375 3.28 1.375 1.28 0 2.383-.462 3.28-1.374m-3.28-8.984c1.57 0 2.931.56 4.043 1.662 1.114 1.104 1.677 2.455 1.677 4.012s-.563 2.908-1.677 4.012C42.986 69.44 41.626 70 40.055 70c-1.569 0-2.93-.56-4.043-1.664s-1.677-2.455-1.677-4.012.565-2.908 1.677-4.012 2.474-1.662 4.043-1.662m22.904 5.156h8.41c-.104-1.142-.55-2.126-1.321-2.927-.793-.823-1.744-1.24-2.828-1.24-1.1 0-2.07.417-2.884 1.241a4.76 4.76 0 0 0-1.377 2.926m4.26-5.158c1.438 0 2.688.558 3.72 1.654 1.026 1.098 1.549 2.42 1.549 3.931l-.028.564h-9.501c.121 1.17.605 2.169 1.443 2.97a4.34 4.34 0 0 0 3.09 1.241c1.396 0 2.575-.525 3.503-1.561l.062-.071.723.69-.061.066C70.545 69.371 69.123 70 67.492 70c-1.541 0-2.878-.56-3.976-1.664s-1.654-2.452-1.654-4.011c0-1.557.529-2.906 1.574-4.01 1.044-1.106 2.317-1.666 3.784-1.666m55.081 1.06c.684.703 1.031 1.704 1.031 2.98v7.087h-1.041v-6.842c0-1.078-.238-1.907-.702-2.464-.461-.55-1.236-.83-2.304-.83-.936 0-1.759.317-2.447.94-.685.624-1.032 1.468-1.032 2.511v6.685h-1.042v-6.842c0-1.078-.236-1.907-.702-2.464-.461-.55-1.236-.83-2.302-.83-.906 0-1.722.346-2.423 1.028s-1.056 1.544-1.056 2.557v6.55h-1.043v-10.9h1.043v1.644c.801-1.242 2.008-1.868 3.591-1.868 1.797 0 3.002.712 3.588 2.12a4.1 4.1 0 0 1 1.601-1.551 4.93 4.93 0 0 1 2.338-.57c1.241 0 2.217.355 2.902 1.06m-46.638 1.336c.869-1.59 2.334-2.394 4.36-2.394h.092v1.147h-.093c-.516 0-1.02.078-1.497.23a4.8 4.8 0 0 0-1.398.739c-.445.331-.802.825-1.066 1.464-.265.642-.398 1.406-.398 2.273v5.272h-1.045V58.873h1.044zm26.348 6.625c.847-.889 1.275-2.014 1.275-3.345 0-1.285-.424-2.4-1.262-3.312-.838-.91-1.879-1.372-3.097-1.372s-2.262.462-3.097 1.372c-.838.912-1.265 2.027-1.265 3.312s.427 2.4 1.265 3.312c.835.912 1.879 1.373 3.097 1.373 1.202 0 2.242-.45 3.084-1.34m1.275-6.548v-2.248h1.044v10.902h-1.044v-2.247a5.1 5.1 0 0 1-1.677 1.73c-.788.49-1.69.74-2.683.74-1.494 0-2.79-.559-3.853-1.663-1.058-1.104-1.595-2.454-1.595-4.011s.537-2.905 1.595-4.01c1.06-1.105 2.357-1.664 3.853-1.664.992 0 1.895.249 2.683.742a5.04 5.04 0 0 1 1.677 1.73m-14.044 6.56c.845-.884 1.275-2.013 1.275-3.357 0-1.286-.424-2.401-1.264-3.313-.836-.911-1.877-1.372-3.096-1.372s-2.261.461-3.097 1.372c-.84.912-1.266 2.026-1.266 3.313 0 1.285.427 2.4 1.266 3.314.836.909 1.88 1.37 3.097 1.37 1.203 0 2.241-.447 3.085-1.328m1.275-6.56v-6.285h1.043v14.939h-1.043v-2.248a5.05 5.05 0 0 1-1.68 1.73c-.785.492-1.688.742-2.68.742-1.496 0-2.794-.56-3.853-1.666-1.06-1.103-1.595-2.453-1.595-4.01s.536-2.905 1.595-4.01c1.06-1.105 2.357-1.665 3.853-1.665.992 0 1.894.25 2.68.742a5.06 5.06 0 0 1 1.68 1.73"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#ws-logo-50_svg__c)">
      <mask
        id="ws-logo-50_svg__d"
        width={184}
        height={122}
        x={0}
        y={-32}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M0 89.738h184V-31.597H0z"
        />
      </mask>
      <g mask="url(#ws-logo-50_svg__d)">
        <path
          fill="#00215B"
          d="M-6.667 76.667h144.68v-49.17H-6.667z"
        />
      </g>
    </g>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWsLogo50);

export default ForwardRef;
